import { Component, createApp } from 'vue';
import { Router } from 'vue-router';
import { VueQueryPlugin } from 'vue-query';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import { globalProperties } from './globalProperties';
import { pinia } from '@/stores';
import i18n from '@/plugins/i18n';
import { setHTTPHeader } from '@/services/http.service';
import AuthService from '@/services/auth.service';

const token = AuthService.getToken();

if (token) {
  setHTTPHeader({ Authorization: token });
}

export const setupEntryPoint = (rootComponent: Component, router: Router) => {
  const app = createApp(rootComponent);

  app.use(router);
  app.use(pinia);
  app.use(i18n);
  app.use(VueQueryPlugin);
  app.use(Toast, {
    position: 'top-right',
    timeout: 3000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: true,
    closeButton: 'button',
    icon: true,
    rtl: false,
  });
  app.config.globalProperties = { ...app.config.globalProperties, ...globalProperties };

  // Make toast available in the composition API
  app.provide('toast', app.config.globalProperties.$toast);

  app.mount('#app');
};
